import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const ActionTableCell = styled(TableCell)`
    width: 1px;
    padding: 6px 16px;
    white-space: nowrap;
    text-align: right;
`;

export const FlexContainer = styled.div`
    @media only screen and (min-width: 700px) {
        display: flex;
    }

    @media only screen and (max-width: 700px) {
        text-align: 'center';

        & > * {
            margin-bottom: 14px;
            display: block;
            margin-left: auto !important;
            margin-right: auto !important;
        }
    }
`;

export const Title = styled(Typography)`
    color: rgba(0, 0, 0, 0.87);
    flex: 1;
`;
